export enum actionTypes {
    MAINTENANCE_MODE_DATA_UPDATE = 'MAINTENANCE_MODE_DATA_UPDATE',
    MAINTENANCE_MODE_IS_LOADING_UPDATE = 'MAINTENANCE_MODE_IS_LOADING_UPDATE',
    MAINTENANCE_MODE_IS_INTEGRATION_SCRIPT_FAILED_UPDATE = 'MAINTENANCE_MODE_IS_INTEGRATION_SCRIPT_FAILED_UPDATE'
}
